import { NgModule } from '@angular/core';

import { LoanTransactionsRoutingModule } from './loan-transactions-routing.module';
import { LoanRepaymentComponent } from './loan-repayment/loan-repayment.component';
import { LoanForeclosureComponent } from './loan-foreclosure/loan-foreclosure.component';
import { LoanCheckReversalComponent } from './loan-checkreversal/loan-checkreversal.component';
import { SharedModule } from 'app/shared/shared.module';
import { SearchModule } from 'app/search/search.module';
import { PipesModule } from 'app/pipes/pipes.module';


@NgModule({
  declarations: [LoanRepaymentComponent, LoanForeclosureComponent, LoanCheckReversalComponent],
  imports: [
    SharedModule,
    LoanTransactionsRoutingModule,
    SearchModule,
    PipesModule,
  ]
})
export class LoanTransactionsModule { }
